import React, { useRef, useEffect, useState } from "react";
import "./style.css";

export default function Overview(props) {
  const [item, setPost] = React.useState();

  //console.log("PropsID", propID);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `https://admin.arabian-industries.net/api/api/collections/entry/group_companies/` +
          props.propID +
          `?token=8c25a7a0819fe42e3a0ddb3adc68b1`,
        {
          method: "get",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
      await response.json().then(function (response) {
        setPost(response);
        //console.log("SD", response);
      });
    };
    fetchData();
  }, [props.propID]);

  if (!item) return;

  return (
    <div
      className="BoxGreen"
      style={{
        backgroundColor: item.grid_background_color,
      }}
    >
      <div className="LeftG">
        <div
          className="bgIMGwtEXT"
          style={{
            backgroundImage: `url(${
              process.env.REACT_APP_IMG + item.two_colom_green_box_image.path
            })`,
          }}
        >
          <div className="titleHolder">{item.two_colom_green_box_title}</div>
          <div className="EFFECT_TwoBOX"></div>
        </div>
      </div>
      <div className="RightG">
        <div
          dangerouslySetInnerHTML={{
            __html: item.two_colom_green_box_content,
          }}
        />
      </div>
      <div className="BGArtround"></div>
      <div className="HoldICONBar">
        <img
          src={`${
            process.env.REACT_APP_IMG + item.two_colom_green_box_icon.path
          }`}
          width="auto"
          height="auto"
          loading="lazy"
          decoding="async"
          className="BoxIcon"
        />
      </div>
    </div>
  );
}
